var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_7331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.75 12.2055V4.0375C29.7512 3.64698 29.6753 3.26006 29.5266 2.89895C29.3779 2.53785 29.1594 2.20966 28.8835 1.93324C28.6076 1.65682 28.2799 1.43761 27.9191 1.28818C27.5583 1.13876 27.1715 1.06206 26.781 1.0625H18.6177C18.0824 1.0636 17.5691 1.27573 17.1893 1.65285L0.869278 17.9682C0.312671 18.5266 0.00012207 19.2829 0.00012207 20.0713C0.00012207 20.8597 0.312671 21.616 0.869278 22.1744L8.63881 29.9439C9.197 30.5006 9.95319 30.8133 10.7416 30.8133C11.5299 30.8133 12.2861 30.5006 12.8443 29.9439L29.1597 13.6339C29.5369 13.2541 29.7491 12.7408 29.75 12.2055V12.2055ZM23.375 9.5625C22.9547 9.5625 22.5439 9.43787 22.1944 9.20437C21.845 8.97088 21.5726 8.639 21.4118 8.2507C21.2509 7.86241 21.2089 7.43514 21.2909 7.02293C21.3728 6.61072 21.5752 6.23209 21.8724 5.9349C22.1696 5.63771 22.5482 5.43533 22.9605 5.35333C23.3727 5.27134 23.7999 5.31342 24.1882 5.47426C24.5765 5.63509 24.9084 5.90746 25.1419 6.25691C25.3754 6.60637 25.5 7.01722 25.5 7.4375C25.5 8.00109 25.2761 8.54159 24.8776 8.9401C24.4791 9.33862 23.9386 9.5625 23.375 9.5625Z",
    fill: "url(#paint0_linear_1612_7331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9374 4.25C32.6557 4.25 32.3854 4.36194 32.1861 4.5612C31.9869 4.76046 31.8749 5.03071 31.8749 5.3125V13.7707L14.5223 31.1239C14.4195 31.2216 14.3373 31.3389 14.2805 31.4689C14.2237 31.5988 14.1936 31.7388 14.1917 31.8806C14.1899 32.0224 14.2165 32.1632 14.2699 32.2945C14.3234 32.4259 14.4026 32.5453 14.5028 32.6455C14.6031 32.7458 14.7225 32.825 14.8538 32.8784C14.9852 32.9319 15.1259 32.9585 15.2678 32.9566C15.4096 32.9548 15.5496 32.9246 15.6795 32.8679C15.8095 32.8111 15.9268 32.7289 16.0244 32.6261L33.4229 15.2276C33.608 15.0417 33.7543 14.8209 33.8533 14.5779C33.9524 14.335 34.0022 14.0748 33.9999 13.8125V5.3125C33.9999 5.03071 33.888 4.76046 33.6887 4.5612C33.4895 4.36194 33.2192 4.25 32.9374 4.25V4.25Z",
    fill: "url(#paint1_linear_1612_7331)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1612_7331",
    x1: 14.8751,
    y1: 1.0625,
    x2: 14.8751,
    y2: 30.8133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#49C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57D737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1612_7331",
    x1: 24.0958,
    y1: 4.25,
    x2: 24.0958,
    y2: 32.9567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#49C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57D737"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1612_7331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing-icon.a441dcb0.svg";
export { ForwardRef as ReactComponent };